import 'reflect-metadata';
import { Relation } from '../../core/decorators/relation.decorator';
import { RelationRef } from '../../core/types/entity-types';
import { BaseEntity } from '../../core/entities/base.entity';
import { LearningSectionEntity } from '../learning-section-entity';
import { SequenceEntity } from '../../sequence/sequence.entity';
import { TestEntity } from '../../test/test.entity';
import { ExplanationEntity } from '../../explanation/explanation-entity';
import { ExplanationContentEntity } from '../../explanation/content/explanation-content-entity';

export class LearningSectionContainerEntity extends BaseEntity {
  title?: string;
  fullWidth?: boolean;
  version?: number;

  @Relation()
  learningSections?: RelationRef<LearningSectionEntity>[];

  @Relation()
  content?: { id: string, type: string } | SequenceEntity | ExplanationContentEntity | ExplanationEntity | TestEntity;
}
